import { i18n } from '@/plugins/i18n'

export const paymanStatus = {
    ACTIVE: 1,
    PENDING: 2,
    REJECTED: 3,
    BLOCKED: 4,
}

export const paymanStatusStr = {
    ACTIVE: i18n.t('payman_status.active'),
    PENDING: i18n.t('payman_status.pending'),
    REJECTED: i18n.t('payman_status.rejected'),
    BLOCKED: i18n.t('payman_status.blocked'),
    get(status) {
        let status_str = null;
        Object.keys(paymanStatus).forEach(function (item) {
            if(paymanStatus[item] === status) {
                status_str = paymanStatusStr[item]
            }
        })

        return status_str
    }
}

export const paymanVariant = (status) => {
    if(status === paymanStatus.ACTIVE) {
        return 'success'
    }

    if(status === paymanStatus.REJECTED || status === paymanStatus.BLOCKED) {
        return 'danger'
    }

    if(status === paymanStatus.PENDING) {
        return 'warning'
    }

    return 'info'
} 